import React from 'react';
import HeroModules from '../components/home/HeroModules';
import AppsHub from '../components/home/AppsHub';
import RecycleSection from '../components/home/recyce_Section/RecycleSection';
import ClientsSection from '../components/home/ClientsSection';
import ServicesSection from '../components/home/ServicesSection';
import AboutSection from '../components/home/AboutSection';
import EventsSection from '../components/home/EventsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import ModalsContainer from '../components/modals/ModalsContainer';

const Home = () => {
  return (
    <>
      <HeroModules />
      <AppsHub />
      <RecycleSection />
      <ClientsSection />
      <ServicesSection />
      <AboutSection />
      <EventsSection />
      <TestimonialsSection />
      <ModalsContainer />
    </>
  );
};

export default Home;

